module.exports = __webpack_public_path__ + "static/img/icon4.988d4d9b.png";